import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WebsocketService } from './websocket.service';
import { environment } from '../../../environments/environment';

const CHAT_URL = environment.charUrl;

@Injectable()
export class FlatStatusNotifierService {
	public messages: Subject<any>;

	constructor(wsService: WebsocketService) {
		this.messages = <Subject<any>>wsService
			.connect(CHAT_URL)
			.pipe(response => response);
	}
}